<template>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.48178 3.79417C2.05438 7.39409 2.19424 13.0909 5.79417 16.5183L12.3124 22.7241L18.5183 16.2059C21.9457 12.6059 21.8058 6.90918 18.2059 3.48178C14.6059 0.0543832 8.90918 0.194243 5.48178 3.79417ZM12.2722 14.2721C14.4813 14.2721 16.2722 12.4813 16.2722 10.2721C16.2722 8.06299 14.4813 6.27213 12.2722 6.27213C10.063 6.27213 8.27216 8.06299 8.27216 10.2721C8.27216 12.4813 10.063 14.2721 12.2722 14.2721Z"
  />
</template>
